export default function () {
  return document.documentMode || /Edge/.test(navigator.userAgent);
}



// WEBPACK FOOTER //
// ./scripts/utils/detect-microsoft.js